<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{ $t("Products.AddProduct") }}
          </h3>
          <CAlert :show.sync="dismissCountDown" color="primary" fade>
            ({{ dismissCountDown }}) {{ message }}
          </CAlert>

          <CInput
            :label="$t('Products.Title')"
            type="text"
            v-model="product.title"
          ></CInput>

          <CSelect
            :label="$t('Products.Batch')"
            :value.sync="product.batch_id"
            :plain="true"
            :options="batches"
          ></CSelect>

          <CRow>
            <CCol col="6">
              <CInput
            :label="$t('Products.Location')"
            type="text"
            v-model="product.location"
          ></CInput>
            </CCol>
            <CCol col="6">
              <CSelect
                :label="$t('Products.State')"
                :value.sync="product.status"
                :plain="true"
                :options="status"
              ></CSelect>
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6">
              <CSelect
                :label="$t('Products.Type')"
                :value.sync="product.product_type_id"
                :plain="true"
                :options="product_types"
              ></CSelect>
            </CCol>

            <CCol col="6">
              <!-- <CSelect label="Taille" :value.sync="product.product_size_id" :plain="true" :options="sizes" ></CSelect> -->
              <label for="Sizes">{{ $t("Products.Size") }}</label>
              <select id="Sizes" v-model="product.product_size_id">
                <optgroup
                  v-for="type in product_types_full"
                  :key="type.id"
                  :label="type.name"
                  v-show="type.id == product.product_type_id"
                >
                  <option
                    v-for="size in type.sizes"
                    :key="size.id"
                    :value="size.id"
                  >
                    {{ size.name }}
                  </option>
                </optgroup>
              </select>
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6">
              <CSelect
                :label="$t('Products.Brand')"
                :value.sync="product.brand_id"
                :plain="true"
                :options="brands"
              ></CSelect>
            </CCol>
            <CCol col="6">
              <CSelect
                :label="$t('Products.Color')"
                :value.sync="product.product_color_id"
                :plain="true"
                :options="colors"
              ></CSelect>
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6">
              <CInput
                :label="$t('Products.PublicationD')"
                type="date"
                v-model="product.live_date"
              ></CInput>
            </CCol>
            <CCol col="6">
              <CInput
                :label="$t('Products.PublicationT')"
                type="time"
                v-model="product.live_time"
              ></CInput>
            </CCol>
          </CRow>

          <CRow>
            <CCol col="6">
              <CSelect
                :label="$t('Products.ExclusivityLimit')"
                :value.sync="product.public_datetime"
                :plain="true"
                :options="time_frames"
              ></CSelect>
            </CCol>
            <CCol col="6">
              <CSelect
                :label="$t('Products.MaleFemale')"
                :value.sync="product.gender"
                :plain="true"
                :options="gender"
              ></CSelect>
            </CCol>
          </CRow>

          <CInput
            :label="$t('Products.Price')"
            type="number"
            v-model="product.price"
          ></CInput>
          <CInput
            :label="$t('Products.Promotion')"
            type="number"
            v-model="product.promo_price"
          ></CInput>

          <CButton color="info" @click="storeAndAgain()" class="w-100">{{
            $t("Products.ReAdd")
          }}</CButton>
          <br />
          <br />
          <CButton color="success" @click="store()" class="w-100">{{
            $t("Button.Add")
          }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{ $t("Products.Photo") }}
          </h3>

          <file-upload
            ref="upload"
            v-model="files"
            :drop="true"
            accept="image/*"
            :multiple="true"
          >
            <CButton class="w-100 btn-primary">{{
              $t("Products.AddPhoto")
            }}</CButton>
          </file-upload>

          <div>
            <div
              :key="file.name"
              v-for="file in files"
              class="text-center product-preview"
              :style="'background-image: url(' + getFilePath(file) + ')'"
            >
              <span @click="removePhoto(file)"
                ><CIcon
                  name="cil-x-circle"
                  class="text-danger float-left"
                  height="24"
                />
              </span>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import {
  batchService,
  brandService,
  colorService,
  productService,
  providerService,
  sizeService,
  typeService,
} from "../../_services";
export default {
  name: "EditUser",
  props: {
    caption: {
      type: String,
      default: "User id",
    },
  },
  data: () => {
    return {
      files: [],
      product: {
        title: "",
        live_date: "",
        live_time: "",
        public_datetime: "00:00",
        product_type_id: "",
        product_size_id: "",
        product_color_id: "1",
        brand_id: "",
        batch_id: "",
        price: "",
        promo_price: "",
        gender: "M",
        location: "",
        status: "1"
      },
      product_types: [],
      batches: [],
      colors: [],
      sizes: [],
      brands: [],
      gender: [
        { value: "M", label: "Homme" },
        { value: "F", label: "Femme" },
        { value: "E", label: "Enfant" },
        { value: "B", label: "Bébé" },
      ],
      status: [
        { value: "1", label: "New with tag" },
        { value: "2", label: "New without tag" },
        { value: "3", label: "Very good state" },
        { value: "4", label: "Good condition" },
        { value: "5", label: "Satisfying" }
      ],
      time_frames: [
        { value: "1", label: "1 Heure" },
        { value: "3", label: "3 Heures" },
        { value: "6", label: "6 Heures" },
        { value: "12", label: "12 Heures" },
        { value: "24", label: "24 Heures" },
        { value: "48", label: "48 Heures" },
      ],
      providers: [
        { value: "js", label: "JavaScript" },
        { value: "html", label: "HTML" },
      ],
      message: "",
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      product_types_full: [],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/users'})
    },
    storeAndAgain() {
      this.loader = this.$loading.show();
      let live_datetime = this.$moment(
        this.product.live_date + " " + this.product.live_time
      );
      let public_datetime = this.$moment(
        this.product.live_date + " " + this.product.live_time
      ).add(this.product.public_datetime, "h");
      let form = new FormData();
      form.append("title", this.product.title);
      form.append("gender", this.product.gender);
      form.append("live_datetime", live_datetime.format("YYYY-MM-DD HH:mm:ss"));
      form.append(
        "public_datetime",
        public_datetime.format("YYYY-MM-DD HH:mm:ss")
      );
      form.append("product_type_id", this.product.product_type_id);
      form.append("product_size_id", this.product.product_size_id);
      form.append("product_color_id", this.product.product_color_id);
      form.append("brand_id", this.product.brand_id);
      form.append("batch_id", this.product.batch_id);
      form.append("price", this.product.price);
      form.append("location", this.product.location);
      form.append("status", this.product.status);
      form.append("promo_price", this.product.promo_price);
      this.files.map(function(obj) {
        form.append("files[]", obj.file);
      });

      productService
        .create(form)
        .then(
          function(data) {
            this.$toast.success("Produit créé avec succès");
            this.message = "added successfully";
            this.showAlert();
            this.$router.push(
              "?batch_id=" +
                this.product.batch_id +
                "&type=" +
                this.product.product_type_id +
                "&gender=" +
                this.product.gender
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.loader.hide();
          }.bind(this)
        );
    },
    store() {
      this.loader = this.$loading.show();
      let live_datetime = this.$moment(
        this.product.live_date + " " + this.product.live_time
      );
      let public_datetime = this.$moment(
        this.product.live_date + " " + this.product.live_time
      ).add(this.product.public_datetime, "h");
      let form = new FormData();
      form.append("title", this.product.title);
      form.append("gender", this.product.gender);
      form.append("live_datetime", live_datetime.format("YYYY-MM-DD HH:mm:ss"));
      form.append(
        "public_datetime",
        public_datetime.format("YYYY-MM-DD HH:mm:ss")
      );
      form.append("product_type_id", this.product.product_type_id);
      form.append("product_size_id", this.product.product_size_id);
      form.append("product_color_id", this.product.product_color_id);
      form.append("brand_id", this.product.brand_id);
      form.append("batch_id", this.product.batch_id);
      form.append("price", this.product.price);
      form.append("location", this.product.location);
      form.append("status", this.product.status);
      form.append("promo_price", this.product.promo_price);
      this.files.map(function(obj) {
        form.append("files[]", obj.file);
      });

      productService
        .create(form)
        .then(
          function(data) {
            this.$toast.success("Produit créé avec succès");
            this.message = "added successfully";
            this.showAlert();
            this.goBack();
          }.bind(this)
        )
        .finally(
          function() {
            this.loader.hide();
          }.bind(this)
        );
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getFilePath(file) {
      file.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(file.file);
      }
      console.log(
        this.files.map(function(obj) {
          return obj.file;
        })
      );
      return file.blob;
    },
    removePhoto(file) {
      this.files.forEach(
        function(item, i) {
          if (this.files[i].name === file.name) {
            this.files.splice(i, 1);
            return false;
          }
        }.bind(this)
      );
    },
    // getProductSizesByType(){
    //   sizeService.getByType(this.product.product_type_id).then(function (data) {
    //     this.sizes = data.data.map(function (obj) {
    //       return { value: obj.id, label: obj.name };
    //     })
    //     this.sizes.product_size_id = this.sizes[0].value;
    //   }.bind(this))
    // }
  },
  mounted() {
    if (this.$route.query.gender) {
      this.product.gender = this.$route.query.gender;
    }

    // alert(0)
    typeService.getAll().then(
      function(data) {
        this.product_types_full = data.data;
        this.product_types = data.data.map(function(obj) {
          return { value: obj.id, label: obj.name };
        });
        this.product.product_type_id = this.product_types[0].value;
        if (this.$route.query.type) {
          this.product.product_type_id = Number(this.$route.query.type);
        }
        // this.getProductSizesByType();
      }.bind(this)
    );

    providerService.getAll().then(
      function(data) {
        this.providers = data.data.map(function(obj) {
          return { value: obj.id, label: obj.name };
        });
        this.product.provider_id = this.providers[0].value;
      }.bind(this)
    );

    batchService.getAll().then(
      function(data) {
        this.batches = data.data.map(function(obj) {
          return { value: obj.id, label: obj.reference };
        });
        this.product.batch_id = this.batches[0].value;
        if (this.$route.query.batch_id) {
          this.product.batch_id = Number(this.$route.query.batch_id);
        }
      }.bind(this)
    );

    brandService.getAll().then(
      function(data) {
        this.brands = data.data.map(function(obj) {
          return { value: obj.id, label: obj.name };
        });
        this.product.brand_id = this.brands[0].value;
      }.bind(this)
    );

    colorService.getAll().then(
      function(data) {
        this.colors = data.data.map(function(obj) {
          return { value: obj.id, label: obj.name };
        });
        this.colors.product_color_id = this.colors[0].value;
      }.bind(this)
    );
  },
};
</script>
<style>
.product-preview {
  width: 150px;
  height: 150px;
  float: left;
  background-position: center;
  background-size: 80% 100%;
  background-repeat: no-repeat;
  margin: 5px;
}
select {
  width: 100%;
  height: 25px;
  border: 1px solid #ddd;
  padding-left: 10px;
  border-radius: 5px;
  color: #888;
}
</style>
